import styled from 'styled-components';
import DialogCTA from '@/components/Dialogs/DialogCTA';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const DialogCTAStyled = styled(DialogCTA)`
  .MuiDialog-paper {
    max-width: 652px;
  }

  .MuiDialogContent-root {
    padding: 35px 16px 40px;
  }

  .dialog-cta {
    &__image-wrapper {
      height: 238px;
      margin: 0 auto 10px;

      img {
        width: 100%;
        max-width: 262px;
      }
    }

    &__title {
      width: 100%;
      margin-bottom: 0;
    }

    &__subtitle {
      margin: 12px 0 24px;
    }
  }

  ${breakpoints.up('md')} {
    .MuiDialogContent-root {
      padding: 35px 24px 40px;
    }

    .dialog-cta {
      &__image-wrapper {
        height: 279px;
        margin-bottom: 7px;

        img {
          max-width: 300px;
        }
      }

      &__subtitle {
        margin-top: 16px;
      }

      &__confirm-btn {
        max-width: 274px;

        align-self: center;
      }
    }
  }
`;

export default DialogCTAStyled;
